import { Component, ElementRef, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {NgStyle} from '@angular/common';

import { EventsService } from '../Events.service';
import {ElectionService} from '../election-service/election.service';
import { SettingsService } from '../settings/settings.service';

// import {TranslatePipe, TranslateService} from 'ng2-translate/ng2-translate';

declare let componentHandler: any;

@Component({
    selector: 'email-panel',
    template: require('./email.component.html')
    // pipes: [TranslatePipe]
})

export class EmailComponent implements OnInit  {
 
    @Input() emailSubject:string;
    @Input() emailBody:string;
    @Output() displayStatus = new EventEmitter<boolean>();


     //General state/admin variables
     error: any;
     appSettings: Object;

     //email
     toAddress:string;
     fromAddress:string; 
     message:Object;
     isDisplayed:boolean = false;

    //  inject necessary services
    constructor(private elRef: ElementRef, private _eventsService: EventsService, public _electionService: ElectionService, private _settingsService: SettingsService) { 
       
       
    }

    //initialize email objects 
    ngOnInit () {
            //update chnages in the DOM
        componentHandler.upgradeAllRegistered();

        //get email inputs
        let fromInput: any = document.getElementById('fromemail');
        let toInput:any = document.getElementById('toemail');

        // //if there is an address in local storage
        this.fromAddress = window.localStorage.getItem("vipFromEmail" );
        this.fromAddress ? toInput.focus() : fromInput.focus();;


        // Get app settings from settings service      
        this._settingsService.getAppSettings().subscribe(
            settings => { 
                this.appSettings = settings
            },
            err => { this.error = true }
        );

        //update chnages in the DOM
        componentHandler.upgradeAllRegistered();
        
        //set necessary styles
        fromInput ? fromInput.parentElement.classList.add('is-dirty'): console.log("from email input is undefined");
        fromInput ? fromInput.parentElement.classList.remove('is-invalid'): console.log("from email input is undefined");
    }



    // destroy 
    ngOnDestroy() {

    }
    
    //emit the event telling the parent component to show the panel
    showPanel() {
        //this.isDisplayed = true;
        this.displayStatus.emit(true)
        
    }

    
    //emit the event telling the parent component to hide the panel
    closePanel() {
       
       this.displayStatus.emit(false)
    }

    //trigger the send email
    sendEmail() {
      
       console.log(this.emailSubject + ": " + this.emailBody);

        //create the message object to send to the service
        this.message = JSON.stringify({ 
            "toAddress": this.toAddress,
            "fromAddress": this.fromAddress,
            "subject": this.emailSubject,
            "body": this.emailBody 
        });

        //submit the email to the server and send
        this._electionService.sharePPViaEmail(this.message);
        
        window.localStorage.setItem("vipFromEmail",this.fromAddress );
        // window.localStorage.setItem("vipToEmail",this.toAddress );
        
        //close the dialog
        this.displayStatus.emit(false)
    }


}


// WEBPACK FOOTER //
// ./app/shared/email/email.component.ts